import React from 'react';
import { Container } from 'react-bootstrap';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import Firstaboutimg from '../../Components/About/Firstaboutimg';
import Secondaboutimg from '../../Components/About/Secondaboutimg';
import Thirdaboutimg from '../../Components/About/Thirdaboutimg';
import Ourspecialitesabout from '../../Components/About/Ourspecialitesabout';

function About() {
    
  return (
    <div>
      <Container fluid style={{ margin: 0, padding: 0, overflowY:'hidden' }} >
        <div>
          <Header title="about"/>
        </div>
        
        <div>
          <Firstaboutimg/>
        </div>
        
        <div>
          <Secondaboutimg/>
        </div>

        <div>
          <Thirdaboutimg/>
        </div>
        
        <div>
          <Ourspecialitesabout/>
        </div>


     <div>
      <Footer/>
     </div>

      </Container>
    </div>
    
  );
}

export default About